'use client'

import dynamic from 'next/dynamic'
import { ComponentType } from 'react'

import { Spinner } from '@/shared/ui'

import '@toast-ui/editor/dist/toastui-editor-viewer.css'

const Viewer = dynamic(
  () =>
    import('@toast-ui/react-editor').then(
      mod => mod.Viewer as unknown as ComponentType<{ initialValue: string }>,
    ),
  {
    ssr: false,
    loading: () => (
      <div className="relative min-h-[600px] py-10">
        <Spinner size="default" className="*:text-[5px]!" />
      </div>
    ),
  },
)

type Props = {
  contents: string
}

export const Content = ({ contents }: Props) => {
  return (
    <div className="relative py-10">
      <Viewer initialValue={contents} />
    </div>
  )
}
